module.exports = __webpack_public_path__ + "static/media/Montserrat-SemiBold.98bf0fc7.woff";